module.exports = __webpack_public_path__ + "img/tu10.2be24195.png";